import React from "react";
import styled from "styled-components";

function DownloadApp() {
  return (
    <Container>
      <Content>
        <Image>
          <img src="./mobile mockup.png" alt="" />
        </Image>
        <Description>
          <TagLine>
            <p>Download our app</p>
          </TagLine>
          <HeadLine>Get the Groceries app order more easily.</HeadLine>
          <Desc>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut.
          </Desc>
          <CTA>
            <div className="sc-45ty6">
              <img src="./icon.png" alt="" />
              <p>App Store</p>
            </div>
            <div className="sc-45ty6">
              <img src="./icon (1).png" alt="" />
              <p>Play Store</p>
            </div>
          </CTA>
        </Description>
      </Content>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin: auto;
  padding: 70px 0;
  background: #fef5f5;
`;
const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 70%;
  margin: auto;

  @media only screen and (max-width: 767px) {
    /* Styles */
    width: 100%;
    flex-direction: column-reverse;
  }
`;
const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  @media only screen and (max-width: 767px) {
    /* Styles */

    width: 90%;
  }
`;
const Image = styled.div`
  width: 50%;
  @media only screen and (max-width: 767px) {
    /* Styles */

    width: 50%;
    margin-top: 50px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 50%;
    margin: auto;
  }
`;
const TagLine = styled.div`
  background: #fdecec;
  border-radius: 23px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: -20px;
  height: 45px;
  /* identical to box height, or 100% */

  display: flex;
  align-items: center;

  color: #f55556;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */
    font-size: 12px;
    width: 140px;
  }
`;
const HeadLine = styled.h2`
  font-family: "Poppins";
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 50px;
  width: 95%;
  /* or 119% */

  letter-spacing: -0.01em;
  margin-bottom: 10px;
  margin-top: 40px;

  color: #2e2e2e;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    font-size: 25px;
    line-height: 38px;
  }

  @media only screen and (max-width: 767px) {
    /* Styles */

    font-size: 25px;
    line-height: 38px;
  }
`;
const Desc = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 23px;
  width: 95%;
  /* or 167% */

  letter-spacing: 0.005em;

  color: #676767;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */
    font-size: 12px;
    line-height: 18px;
  }

  @media only screen and (max-width: 767px) {
    /* Styles */

    /* Styles */
    font-size: 12px;
    line-height: 18px;
  }
`;
const CTA = styled.div`
  margin-top: 20px;

  display: flex;
  align-items: center;
  .sc-45ty6 {
    margin-right: 15px;
    border: 1.5px solid #eedcdc;
    box-sizing: border-box;
    border-radius: 12px;
    width: 200px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-right: 10px;
      @media only screen and (min-width: 768px) and (max-width: 1024px) {
        /* Styles */
        width: 30px;
        height: 30px;
      }
    }

    p {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height, or 100% */

      color: #2e2e2e;
      @media only screen and (min-width: 768px) and (max-width: 1024px) {
        /* Styles */

        font-size: 12px;
      }
    }
  }
`;

export default DownloadApp;
